export class Crop{
    X: number;
    Y: number;
    Width: number;
    Height: number;
}